import { render, staticRenderFns } from "./ConfirmTemplate.vue?vue&type=template&id=a61e1a62"
import script from "./ConfirmTemplate.vue?vue&type=script&lang=js"
export * from "./ConfirmTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports